import React, { Component, useState, useRef, Fragment } from 'react';
import { sagaModal } from 'redux-saga-modal';
import { Form, Modal, Button, message, Row, Col, Checkbox, Spin } from 'antd';
import * as apis from '@/apis';
import styles from './staffRoles.module.scss';
import QRCode from 'qrcode.react';

const formItemLayout = {
  labelCol: { span: 7 },
  wrapperCol: { span: 15 },
};

@Form.create()
class StaffRoles extends Component {
  state = {
    loading: false,
    transaction: null,
  };

  handleSubmit = (e) => {
    const { submit, permissions } = this.props;
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (err) {
        Object.entries(err).forEach(([_, { errors }]) => {
          errors.forEach(({ message: msg }) => {
            message.error(msg);
          });
        });

        return console.error(err);
      }

      apis.setPermissions(this.props.id, { permissions: values.permissions })
        .then(res => {
          this.setState({
            loading: false
          })
          this.props.submit()
        })
        .catch(err => {
          message.error(err.message || 'API异常，请稍后再试')
          this.setState({
            loading: false
          })
        })
    });
  };

  render() {
    // TODO
    const {
      getFieldDecorator,
      validateFields,
      getFieldValue,
    } = this.props.form;
    // console.log('permissions:', this.props.permissions)
    return (
      <div>
        <Spin spinning={this.state.loading}>
          <Form onSubmit={this.handleSubmit}>
            <div>
            {getFieldDecorator('permissions', {
                normalize: this.normalizeTenant,
                initialValue: this.props.permissions || [],
                rules: [
                  {
                    required: true,
                    message: '权限',
                  },
                ],
              })(
                <Checkbox.Group style={{ width: '100%' }}>
                  <Row>
                    <Col span={8}>
                      <Checkbox value="employees:all">员工管理</Checkbox>
                    </Col>
                    <Col span={8}>
                      <Checkbox value="configure:all">工单配置</Checkbox>
                    </Col>
                    <Col span={8}>
                      <Checkbox value="finances:all">财务信息</Checkbox>
                    </Col>
                    <Col span={8}>
                      <Checkbox value="orders:all">工单列表</Checkbox>
                    </Col>
                    <Col span={8}>
                      <Checkbox value="products:all">产品信息</Checkbox>
                    </Col>
                    <Col span={8}>
                      <Checkbox value="workspace:all" disabled>工作台</Checkbox>
                    </Col>
                  </Row>
                </Checkbox.Group>
              )}
            </div>
            <div className={styles.footer}>
              <Button type="primary" htmlType="submit">
                保存
              </Button>
            </div>
          </Form>
        </Spin>
      </div>
    );
  }
}

const StaffRolesDialog = ({
  modal,
  isOpen,
  show,
  update,
  destroy,
  click,
  submit,
  hide,
  showModal,
  updateModal,
  submitModal,
  clickModal,
  hideModal,
  destroyModal,
  ...ownProps
}) => (
  <Modal
    title={ownProps.title}
    destroyOnClose
    footer={null}
    width={500}
    centered
    visible={isOpen}
    onCancel={hide}
  >
    <StaffRoles submit={submit} {...ownProps} />
  </Modal>
);

export default sagaModal({
  name: 'STAFF_ROLES_DIALOG',
})(StaffRolesDialog);
